document.addEventListener("latte:init", init);
function init () {
    $('.vertical-hover').find('.tile-block--hover').find('span').find('p').each(function () {
        $(this).closest('.vertical-hover').css({ "min-height": $(this).height() + 40 });
    });

    //onclick open chat window
    $('.startChat').click(function () {
        var startChat = window._genesys.widgets.bus.registerPlugin('startChat' + _.uniqueId());
        startChat.command('WebChat.open');
    });

    $(function () {
        $('.tile').each(function () {
            tallest = 0;
            $(this).find('.tile-block--hover').each(function () {
                if (tallest <= $(this).height()) {
                    tallest = $(this).height();
                }
            });
            $(this).find('.js-icon').each(function () {
                if (tallest <= $(this).height()) {
                    tallest = $(this).height() + 40;
                }
            });
            $(this).find('.tile-block').each(function () {
                if (tallest <= $(this).height()) {
                    tallest = $(this).height();
                }
            });
            $(this).find('.tile-hover').css({ "min-height": tallest + 30 });
            $(this).find('.vertical-hover').css({ "min-height": tallest + 30 });
            $(this).find('.vertical-hover').find('.row').css({ "min-height": tallest + 30 });
            $(this).find('.tile-block--hover').css({ "min-height": tallest + 30 });
        });

    });

    $(function () {
        tallestlink = 0;
        $('.tile-block.tile-link').each(function () {
            if (tallestlink <= $(this).height()) {
                tallestlink = $(this).height();
            }
        });
        $('.tile-block.tile-link').css({ "height": tallestlink + 30 });
    });

    $('.tile-block.vertical-hover').click(function () {
        if ($(this).hasClass('active-tile')) {
            $(this).removeClass('active-tile');

        } else {
            $('.tile-block.vertical-hover').removeClass('active-tile');
            $(this).addClass('active-tile');
        }
    });

    $('.tile-hover').click(function () {

        if ($(this).hasClass('hover')) {
            $(".tile-hover").removeClass('hover');
        } else {
            $(".tile-hover").removeClass('hover');
            $(this).addClass('hover');
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./public/js/spotlight.js
// module id = 89
// module chunks = 0